/**
 * @generated SignedSource<<98d7afe488951f6af86bbb460023de8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoTagButtonContentActive_todoCategoryTag$data = ReadonlyArray<{
  readonly color: string;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "TodoTagButtonContentActive_todoCategoryTag";
}>;
export type TodoTagButtonContentActive_todoCategoryTag$key = ReadonlyArray<{
  readonly " $data"?: TodoTagButtonContentActive_todoCategoryTag$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTagButtonContentActive_todoCategoryTag">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TodoTagButtonContentActive_todoCategoryTag",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "type": "TodoCategoryTag",
  "abstractKey": null
};

(node as any).hash = "c3e3d9799ea508815cfe792de374a10c";

export default node;
